
export * from './PeopleTile'
